import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { Select, MenuItem, Box } from '@material-ui/core'
import { ANTICIPATION_INDEX, CANCELLED_SHOWS_INDEX, TOP_CONTENT_INDEX, TRENDING_INDEX } from '../../constants/commons'

export class GlobalAttentionHeaderComponent extends Component {
  static propTypes = {
    selectedView: PropTypes.string,
    setSelectedView: PropTypes.func,
    fetchAnticipationIndexDetails: PropTypes.func,
    fetchTopContentIndexDetails: PropTypes.func
  }

  handleViewChange = (event) => {
    this.props.setSelectedView(event.target.value)
  }

  render () {
      return (
        <Row className="header audience attention">
          <Col>
            <Box className='headWrap'>
              <ul className="hFirstRow balanceVerticalAlign">
                <li className="imgHolder">
                  <div id='attention_header_img'>
                    <img src="/static/images/insights_black.svg" alt="logo" className="imgThumb" onError={(e)=>{e.target.style = 'display: none;';}} />
                  </div>
                </li>
                <li>
                  <Select
                    labelId="select-filled-label"
                    id="select-filled"
                    className='streamSelect'
                    value={this.props.selectedView}
                    onChange={(e) => this.handleViewChange(e)}
                  >
                    <MenuItem value={ANTICIPATION_INDEX} className='optionBox'>
                      <Box className="d-flex flex-column pt-1">
                        <span className="optionLabel">Anticipation Index</span>
                      </Box>
                    </MenuItem>
                    <MenuItem value={TOP_CONTENT_INDEX} className='optionBox'>
                      <Box className="d-flex flex-column pt-1">
                        <span className="optionLabel">Top Content Index</span>
                      </Box>
                    </MenuItem>
                    <MenuItem value={TRENDING_INDEX} className='optionBox'>
                      <Box className="d-flex flex-column pt-1">
                        <span className="optionLabel">Trending Index</span>
                      </Box>
                    </MenuItem>
                    <MenuItem value={CANCELLED_SHOWS_INDEX} className='optionBox'>
                      <Box className="d-flex flex-column pt-1">
                        <span className="optionLabel">Cancelled Shows Index</span>
                      </Box>
                    </MenuItem>
                  </Select>
                </li>
              </ul>
            </Box>
          </Col>
        </Row>
      )
  }
}

export default GlobalAttentionHeaderComponent
